/** Read both legacy HTTP-200 errors and rejected JSON responses from callAPI. */
export function getAccessCodeError(error, t) {
    const retryMessage = t("Something went wrong. Please try again.");
    if (!error || typeof error !== "object" || error instanceof Error) {
        return retryMessage;
    }
    if ("httpStatusCode" in error &&
        (typeof error.httpStatusCode !== "number" ||
            ![200, 400, 403, 409, 422, 429].includes(error.httpStatusCode))) {
        return retryMessage;
    }
    if ("errorMessage" in error && typeof error.errorMessage === "string") {
        return error.errorMessage || t("The code is not valid");
    }
    if ("error" in error && typeof error.error === "string") {
        switch (error.error) {
            case "JOB_MISMATCH":
                return t("The access code is not valid for this photo shoot");
            case "CODE_ALREADY_USED":
                return t("The registration code has already been used. Please check your email receipt for information on how to update the registration.");
            case "SUBJECT_NOT_FOUND":
            case "INVALID_CODE":
                return t("The code is not valid");
            case "INVALID_USER":
                return t("You cannot add picture sets with this account.");
            default:
                return error.error || t("The code is not valid");
        }
    }
    return t("The code is not valid");
}
